// --------------------------------------------------------------
// Created On: 2026-03-20
// Author: Dimitra Weinstein
//
// Last Modified: 2026-05-01
// Modified By: Dimitra Weinstein
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------
import React from "react";

// Row in the list of subsidiaries on the Manage Subsidiaries page,
// displaying the subsidiary company's name.
export default function SubsidiaryListRow(props: Props): Component {
  return (
    <div className="p-2" data-test="subsidiary-list-row">
      <span>{props.companyName}</span>
    </div>
  );
}

interface Props {
  companyId: number;
  companyName: string;
}
